import './generalInfoModal.scss';
export class GeneralInfoModalController {
    static $inject = ['close'];
    constructor(close) {
        this.close = close;
        this._close = this.close;
    }
    confirm() {
        this._close(true);
    }
    cancel() {
        this._close(false);
    }
}
GeneralInfoModalController.$inject = ['close'];
